function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { boxShadow } from "../../ThemeProvider/cssFor";
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
function buildStyle(param, param1) {
    var font = param.font, backgroundColor = param.backgroundColor, depth = param.depth, readingDirection = param1.readingDirection, start = param1.start;
    var _obj;
    return {
        appSwitcher: {
            base: (_obj = {
                background: backgroundColor.click.base,
                height: 56,
                padding: '0 6px'
            }, _defineProperty(_obj, start.margin, 14), _defineProperty(_obj, "display", 'flex'), _defineProperty(_obj, "alignItems", 'center'), _defineProperty(_obj, "justifyContent", 'center'), _defineProperty(_obj, "boxSizing", 'content-box'), _defineProperty(_obj, "width", 45), _obj),
            menu: _objectSpread({}, readingDirection, {
                width: 360,
                fontFamily: font.base.family,
                backgroundColor: backgroundColor.click.base,
                boxSizing: 'border-box',
                boxShadow: boxShadow(depth.boxShadow.hard),
                overflow: 'auto',
                padding: '8px 0',
                ul: {
                    listStyle: 'none',
                    margin: 0,
                    padding: 0
                }
            })
        }
    };
}
export default function useStyle(param) {
    var isRtl = param.isRtl, breakpoints = param.breakpoints;
    var builtStyle = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    if (!builtStyle) {
        return {
            containerStyles: {},
            menuStyles: {}
        };
    }
    var appSwitcher = builtStyle.appSwitcher;
    return {
        containerStyles: _objectSpread({}, appSwitcher.base),
        menuStyles: _objectSpread({}, appSwitcher.menu, _defineProperty({}, "@media (max-width: ".concat(breakpoints.m, "px)"), {
            width: '100vw'
        }))
    };
};
